import { Tooltip } from '@mui/material';

interface TruncatedTextWithTooltipProps {
  value?: string | null;
  fallback?: string;
  className?: string;
}

export function TruncatedTextWithTooltip({
  value,
  fallback = `-`,
  className = ``,
}: TruncatedTextWithTooltipProps) {
  const displayValue = value?.trim() || fallback;

  return (
    <Tooltip
      title={ displayValue }
      disableHoverListener={ !value || displayValue === fallback }
    >
      <span className={ `block truncate ${className}` }>
        { displayValue }
      </span>
    </Tooltip>
  );
}
